import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import 'styles/App.scss';
import 'swiper/swiper.scss';
import Intro from 'components/views/Intro';
import Main from 'components/views/Main';
import AgeJail from 'components/views/AgeJail';
import AgeGate from 'components/views/AgeGate';
import { ScreenAdjustments } from 'components/utils/helpers';
import Stats from 'stats.js';
import overlayImg from 'static/images/overlay_img.png';

console.log("env: ", process.env.REACT_APP_ENV)

const App = () => {
  // State
  const [unavailableOnDevice, setUnavailableOnDevice] = useState(false);
  // Hacks to get screen correctly sized on mobile,
  // with correct vh units
  ScreenAdjustments();

  /**
   * Check if we're on Safari version < 13
   */
  useEffect(() => {
    navigator.browserSpecs = (function(){
      var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1] || '')};
      }
      if(M[1]=== 'Chrome'){
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem != null) return {
          name:tem[1].replace('OPR', 'Opera'),version:tem[2]
        }
      }
      M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem = ua.match(/version\/(\d+)/i))!= null)
      M.splice(1, 1, tem[1]);
      return {name:M[0], version:M[1]};
    })();
    console.log(navigator.browserSpecs);
    if (navigator.browserSpecs.name &&
      navigator.browserSpecs.name === 'Safari' &&
      navigator.browserSpecs.version &&
      parseInt(navigator.browserSpecs.version, 10) < 13) {
      setUnavailableOnDevice(true);
    }
    const keepItUp = async () => {
      // eslint-disable-next-line
      let wakeLock = null;
      // create an async function to request a wake lock
      try {
        wakeLock = await navigator.wakeLock.request('screen');
      } catch (err) {
        console.log(`Wakelock not available: ${err}`);
      }
    }
    keepItUp();
  }, []);

  /**
   * Run the monitor panel,
   * for debugging purposes
   */
  useEffect(() => {
    if (window.location.search.indexOf('monitor') !== -1) {
      var stats = new Stats();
      stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
      document.body.appendChild( stats.dom );
      function animate() {
        stats.begin();
        // monitored code goes here
        stats.end();
        requestAnimationFrame( animate );
      }
      requestAnimationFrame( animate );
    }
  }, []);
  return (
      <>
        <Router>
          <Switch>
            <Route exact path='/' component={AgeGate} />
            <Route exact path='/intro' component={Intro} />
            <Route exact path='/main' component={Main} />
            <Route exact path='/not-available' component={AgeJail} />
          </Switch>
        </Router>
        <div className='Overlay'>
          <figure className='Overlay__img' role='img' aria-label='Rotate your phone sidways & turn up the volume' style={{backgroundImage: `url(${overlayImg})`}}></figure>
        </div>
        {unavailableOnDevice && (
          <div className='GenericAlert'>
            <h1 className='GenericAlert__title'>Sorry</h1>
            <section className='GenericAlert__description'>
              <p>This experience is unavailable on your version of Safari. Please upgrade to version 13 or greater.</p>
            </section>
          </div>
        )}
      </>
  );
}

export default App;
